import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';
import Authenticate from 'Minetilbud/Shared/Components/Api/Authenticate';

const log = debug('FrontPageCatalogs:Data:Favorites');
const authenticate = new Authenticate();

class Favorites {
	static dataset;
	static toggleUrl;
	static url;

	/**
	 * @returns {Promise} favorites
	 */
	async get() {
		if (Favorites.dataset !== undefined) return Favorites.dataset;

		try {
			const profile = await authenticate.Profile();
			Favorites.toggleUrl = profile._links.favoritestoggle.href;
			Favorites.url = profile._links.favorites.href;

			let dataset = await authenticate.Url({
				method: 'get',
				url: '/api/v7/profile' + Favorites.url
			});

			if (queryString.Get('favorite')) {
				dataset = this.addFromQueryString(dataset);
			}

			Favorites.dataset = dataset;
			return dataset;
		} catch(error) {
			log('get() - error', error);
		}
	}
}

export default Favorites;
